import { useSelector } from 'react-redux';
import type { RootState } from 'store';

export type SelectedUnitProps<T> = {
  id: string;
  unitInfo: T;
};

export function withSelectedUnit<
  TProps,
  T,
  TInjectedKeys extends keyof SelectedUnitProps<T>,
>(Component: React.JSXElementConstructor<TProps>) {
  return function Injected(props: Omit<TProps, TInjectedKeys>) {
    const { activeUnit, units } = useSelector(
      (state: RootState) => state.unitConnGroup.present.unitState,
    );
    const unit = units.find((u) => u.key === activeUnit);

    if (!unit || !activeUnit) {
      return <></>;
    }

    return (
      <Component
        {...(props as TProps)}
        id={activeUnit}
        unitInfo={unit.unitInfo}
      />
    );
  };
}
